<div class="c-page-employeegeneral"> </div>
      <div class="container u-pb60">
        <div class="row mobile--orange u-pt30">
          <div class="col-md-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a  [routerLink]="['/']"> {{'EmployeeAccessPortal.home' | translate}}</a></li>
                <li class="breadcrumb-item active" aria-current="page">-  </li><span>{{'EmployeeAccessPortal.location' | translate}}</span>
              </ol>
            </nav>
            <h2 class="o-title">{{'EmployeeAccessPortal.title' | translate}} </h2>
            <p class="o-text">{{'EmployeeAccessPortal.titleDescription' | translate}}</p>
          </div>
        </div>
        <form class="o-form"[formGroup]="formAccessEmployee" (ngSubmit)="onSubmit()">
          <div class="row u-pt20">
            <div class="col-md-12" id="siteSection">
              <h2 class="o-title o-title--medium o-title--orange">{{ 'EmployeeAccessPortal.requestTitle' | translate}}</h2>
              <p class="o-text">{{ 'EmployeeAccessPortal.requestSubtitle' | translate}}</p>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-6">
              <div class="form-group u-pb20">
                <label class="o-title o-title--label o-title--required">Country</label>
                    <select name="siteId" class="o-form__select" required style="cursor:pointer" >
                        <option [value]="''" disabled selected>{{ 'EmployeeAccessPortal.selOption' | translate}}</option>
                        <option [value]="country.name" >{{country.name}}</option>
                     </select>

              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group u-pb20" >
                <label class="o-title o-title--label o-title--required">{{'EmployeeAccessPortal.labelsite' | translate}} </label>
                <select name="site" class="o-form__select" required style="cursor:pointer" formControlName="siteId" (change)="changeSelectSite($event.target.value)" >
                    <option [value]="''" disabled selected>{{ 'EmployeeAccessPortal.selOption' | translate}}</option>
                    <option [value]="site.id" *ngFor="let site of site">{{site.name}}</option>
                </select>
                <div *ngIf="formAccessEmployee.controls['siteId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.selectOneOption' | translate}}</mat-error></h5></span>
              </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group u-pb20">
                <label class="o-title o-title--label o-title--required">{{'EmployeeAccessPortal.labelzone' | translate}} </label>
                <select name="zone" class="o-form__select" required style="cursor:pointer" formControlName="zoneId" (change)="changeNotBuGetApprover($event.target.value)"
                            [attr.disabled]="formAccessEmployee.controls['siteId'].hasError('required') ? true : null"
                            bind-style.background-color="formAccessEmployee.controls['siteId'].hasError('required') ? '#F2F0E9' : ''"
                            bind-style.cursor="formAccessEmployee.controls['siteId'].hasError('required') ? 'no-drop' : ''" required >
                    <option [value]="''" disabled selected>{{ 'EmployeeAccessPortal.selOption' | translate}}</option>
                    <!-- <option [value]="zone.code1Sap" *ngFor="let zone of selectZone">{{zone.name}}</option> -->
                    <option [value]="zone.id" *ngFor="let zone of selectZone">{{zone.name}}</option>
                </select>
                <div *ngIf="formAccessEmployee.controls['zoneId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.selectOneOption' | translate}}</mat-error></h5></span>
              </div>
              </div>
            </div>

            </div>
            <div class="row  u-pb20 u-mb20">
                <div class="col-md-12 elementDiv"   *ngIf="((description!==null)&&(oneSapSite!=='0000'))">
                    <span class="elementSpan">{{description}}</span>
                </div>
            </div>

            <div class="row  u-pb20 u-mb20">
              <div class="col-md-12 elementDiv"   *ngIf="oneSapSite==='0000'">
                  <span class="elementSpan">{{ 'EmployeeAccessPortal.msgCas' | translate}}<i class="icon icon-close"></i></span>
              </div>
          </div>

          <div class="row u-pb20 u-mb20">
            <div class="col-md-12" id="subzoneQ">
              <label class="o-title o-title--label o-title--required">{{'EmployeeAccessPortal.labelQuestion' | translate}}</label>
              <label class="o-text o-text--description">{{'EmployeeAccessPortal.questionDescription' | translate}}</label>
              <div class="form-check-group">
                <div class="form-check" [formGroup]="RadioGroup">
                  <input class="form-check-input " id="exampleRadios5" type="radio" name="radioBtn" value="true" formControlName="radioBtn" (change)="cleanSubzoneBU()" required  >
                  <label class="form-check-label" for="exampleRadios5">{{'EmployeeAccessPortal.optionYes' | translate}} </label>
                </div>
                <div class="form-check" [formGroup]="RadioGroup">
                  <input class="form-check-input" id="exampleRadios6" type="radio" name="radioBtn" value="false" formControlName="radioBtn" (change)="cleanSubzoneBU()" required  >
                  <label class="form-check-label" for="exampleRadios6">{{'EmployeeAccessPortal.optionNo' | translate}} </label>
                </div>
              </div>
            </div>
          </div>

          <!--First approver-->
            <!--ZONE-->
          <div class="row" *ngIf="approverFacilityZone && approverFacilityZone.state && approverFacilityZone.priority===true && RadioGroup.value.radioBtn=='false'" >
            <div class="col-md-12">
              <label class="o-title o-title--label ">{{'EmployeeAccessPortal.firstApprover' | translate}}</label>
            </div>
            <div class="col-md-12" style="padding-bottom: 50px;"  >
              <p> <strong> {{ 'EmployeeAccessPortal.labelApproverName' | translate }}:</strong> {{approverFacilityZone.fullName}}</p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilityZone.phone}}</p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverEmail' | translate }}:</strong> {{approverFacilityZone.email}}</p>
            </div>
          </div>

            <!--SUB-ZONE-->
          <div class="row" *ngIf="approverFacilitySubZone && approverFacilitySubZone.state && approverFacilitySubZone.priority===true && RadioGroup.value.radioBtn=='true'" >
            <div class="col-md-12">
              <label class="o-title o-title--label ">{{'EmployeeAccessPortal.firstApprover' | translate}}</label>
            </div>
            <div class="col-md-12" style="padding-bottom: 50px;"  >
              <p> <strong> {{ 'EmployeeAccessPortal.labelApproverName' | translate }}:</strong>  {{approverFacilitySubZone.fullName}}</p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilitySubZone.phone}}</p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverEmail' | translate }}:</strong>{{approverFacilitySubZone.email}}</p>
            </div>
          </div>
          <!-- ---------------------------------------- -->
            <div class="row" *ngIf="this.RadioGroup.value.radioBtn=='true'">

              <div class="col-md-6"  >
                <div class="form-group u-pb20">
                  <label class="o-title o-title--label o-title--required">{{'EmployeeAccessPortal.subzoneAccess' | translate}}</label>
                  <select name="subZone" class="o-form__select " required style="cursor:pointer" formControlName="subZoneId" (change)="getApproverSubZone($event.target.value)"
                      [attr.disabled]="formAccessEmployee.controls['zoneId'].hasError('required') ? true : null"
                      bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : ''"
                      bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') ? 'no-drop' : ''" required >
                      <option [value]="''" disabled selected>{{ 'EmployeeAccessPortal.selOption' | translate}}</option>
                      <option [value]="subZone.id" *ngFor="let subZone of selectSubZone">{{subZone.name}}</option>
                  </select>
                  <div *ngIf="selectSubZone.length===0 && !formAccessEmployee.controls['zoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.msgNotSubzone' | translate}}</mat-error></h5></span>
                  </div>
                  <div *ngIf="formAccessEmployee.controls['subZoneId'].hasError('required') && submited " style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.selectOneOption' | translate}}</mat-error></h5></span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                  <div class="form-group u-pb30">
                    <label class="o-title o-title--label o-title--required js-txt18">{{'EmployeeAccessPortal.siteAccessApproverSubZone' | translate}}:
                      <!-- <div class="title--tooltip" data-toggle="tooltip" data-placement="top" title="Tooltip on top">?</div> -->
                    </label>
                    <div class="content-filter__group">
                      <input *ngIf="formAccessEmployee.controls['subZoneId'].hasError('required')" 
                        type="text" class="o-form__select" matInput [formControl]="toFormControl(formAccessEmployee.controls['accessApproverId'])" [matAutocomplete]="auto2"
                        
                        bind-style.background-color="formAccessEmployee.controls['subZoneId'].hasError('required') ? '#F2F0E9' : ''" 
                        bind-style.cursor="formAccessEmployee.controls['subZoneId'].hasError('required') ? 'no-drop' : ''" required
                      >
                        <input *ngIf="!formAccessEmployee.controls['subZoneId'].hasError('required')" type="text" class="o-form__select" matInput [formControl]="toFormControl(formAccessEmployee.controls['accessApproverId'])"  [matAutocomplete]="auto2"
                        [attr.disabled]="formAccessEmployee.controls['subZoneId'].hasError('required') ? true : null"
                        bind-style.background-color="formAccessEmployee.controls['subZoneId'].hasError('required') ? '#F2F0E9' : ''"
                        bind-style.cursor="formAccessEmployee.controls['subZoneId'].hasError('required') ? 'no-drop' : ''" required 
                        >
                        <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                          <mat-option *ngFor="let option of filteredOptionsApproverSubzone | async" [value]="option">
                            <span mat-raised-button 
                            aria-label="Button that displays a tooltip in various positions">
                            {{option.name}}
                            </span> <br>
                            <small style="color: #E65400">{{option.email}}</small>
                          </mat-option>
                        </mat-autocomplete>
                    </div>
<!--
                    <select name="subZone" class="o-form__select" required style="cursor:pointer" formControlName="accessApproverId" 
                    [attr.disabled]="formAccessEmployee.controls['subZoneId'].hasError('required') ? true : null"
                    bind-style.background-color="formAccessEmployee.controls['subZoneId'].hasError('required') ? '#F2F0E9' : ''"
                    bind-style.cursor="formAccessEmployee.controls['subZoneId'].hasError('required') ? 'no-drop' : ''" required
                    >
                      <option [value]="''" disabled selected>{{ 'EmployeeAccessPortal.selOption' | translate}}</option>
                      <option [value]="approver.mdmid" *ngFor="let approver of approvers">{{approver.name | titlecase }}</option>
                  </select>
                  <div *ngIf="approvers.length===0 && !formAccessEmployee.controls['subZoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.msgNotApprover' | translate}}</mat-error></h5></span>
                  </div>
                  <div *ngIf="formAccessEmployee.controls['accessApproverId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.selectOneOption' | translate}}</mat-error></h5></span>
                </div>
-->
                <div *ngIf="approvers.length===0 && !formAccessEmployee.controls['subZoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.msgNotApprover' | translate}}</mat-error></h5></span>
              </div>
              <div *ngIf=" (formAccessEmployee.controls['accessApproverId'].value.mdmid==='' || formAccessEmployee.controls['accessApproverId'].value.mdmid===undefined ||formAccessEmployee.controls['accessApproverId'].value.mdmid===null) && submited" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.selectOneOption' | translate}}</mat-error></h5></span>
                </div>
                  </div>
                </div>


              </div>

          <div class="row u-pb20 u-mb20"  *ngIf="this.RadioGroup.value.radioBtn=='true'">
                  <div class="col-md-12 elementDiv" *ngIf="descriptionSubzone!==null" >
                      <span class="elementSpan">{{descriptionSubzone}}</span>
                  </div>

           </div>


          <div class="row" *ngIf="this.RadioGroup.value.radioBtn=='false'">
            <div class="col-md-6">
              <div class="form-group u-pb30">
                <label class="o-title o-title--label o-title--required js-txt18">{{'EmployeeAccessPortal.siteApprover' | translate}}:
                </label>

                <div class="content-filter__group">
                  <input *ngIf="formAccessEmployee.controls['zoneId'].hasError('required')"
                    type="text" class="o-form__ie_select o-form__select" matInput [formControl]="ApproverId" [matAutocomplete]="auto"
                    readonly="readonly"
                    bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : ''"
                    bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') ? 'no-drop' : ''" required
                  >
                    <input *ngIf="!formAccessEmployee.controls['zoneId'].hasError('required')"
                           type="text" class="o-form__ie_select o-form__select" matInput [formControl]="ApproverId" [matAutocomplete]="auto"
                    [attr.disabled]="formAccessEmployee.controls['zoneId'].hasError('required') ? true : null"
                    bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : ''"
                    bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') || approvers.length===0 ? 'no-drop' : ''" required
                    >
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                        <span mat-raised-button
                        aria-label="Button that displays a tooltip in various positions">
                        {{option.name}}
                        </span> <br>
                        <small style="color: #E65400">{{option.email}}</small>
                      </mat-option>
                    </mat-autocomplete>
                    <div *ngIf="filteredOptions && approvers.length===0 && !formAccessEmployee.controls['zoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "> <i class="icon icon-close" style="margin-right: 5px;"></i>{{ 'EmployeeAccessPortal.msgNotApprover' | translate}}</mat-error></h5></span>
                    </div>
                </div>



                <!-- <select autocomplete="true" name="subZone" class="o-form__select" required style="cursor:pointer" formControlName="accessApproverId"
                [attr.disabled]="formAccessEmployee.controls['zoneId'].hasError('required') ? true : null"
                bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : ''"
                bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') ? 'no-drop' : ''" required
                >
                  <option [value]="''" disabled selected>{{ 'EmployeeAccessPortal.selOption' | translate}}</option>
                  <option [value]="approver.mdmid" *ngFor="let approver of approvers">{{approver.name }}</option>
              </select> -->
              <div *ngIf="this.RadioGroup.value.radioBtn === 'false' && (this.ApproverId.value.mdmid==='' || this.ApproverId.value.mdmid===undefined ||this.ApproverId.value.mdmid===null) && submited" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'EmployeeAccessPortal.selectOneOption' | translate}}</mat-error></h5></span>
            </div>
              </div>
            </div>
          </div>
          <!--APROVER FACILITY IF SECOND-->
             <!--ZONE-->
          <div class="row" *ngIf="approverFacilityZone && approverFacilityZone.state && approverFacilityZone.priority===false && RadioGroup.value.radioBtn=='false'">
            <div class="col-md-12">
              <label class="o-title o-title--label ">{{ 'EmployeeAccessPortal.secondApprover' | translate }}</label>
            </div>
            <div class="col-md-12" style="padding-bottom: 50px;"  >
              <p> <strong> {{ 'EmployeeAccessPortal.labelApproverName' | translate }}:</strong> {{approverFacilityZone.fullName}} </p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilityZone.phone}}</p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverEmail' | translate }}:</strong>{{approverFacilityZone.email}}</p>
            </div>

          </div>
              <!--SUB-ZONE-->
          <div class="row" *ngIf="approverFacilitySubZone && approverFacilitySubZone.state && approverFacilitySubZone.priority===false && RadioGroup.value.radioBtn=='true'">
            <div class="col-md-12">
              <label class="o-title o-title--label ">{{ 'EmployeeAccessPortal.secondApprover' | translate }}</label>
            </div>
            <div class="col-md-12" style="padding-bottom: 50px;"  >
              <p> <strong> {{ 'EmployeeAccessPortal.labelApproverName' | translate }}:</strong> {{approverFacilitySubZone.fullName}}</p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilitySubZone.phone}}</p>   <p><strong> {{ 'EmployeeAccessPortal.labelApproverEmail' | translate }}:</strong>{{approverFacilitySubZone.email}}</p>
            </div>

          </div>
          <!-- ---------------------------------------- -->


          <div class="row" id="dateFormMAT">
            <div class="col-md-4 col-sm-6">

              <div class="form-group" >
                <label class="o-title o-title--required o-title--label ">{{'EmployeeAccessPortal.labelFrom' | translate}}</label>
                <mat-form-field style="width: 100%;" appearance="standard">

                  <input matInput [min]="todayDate" [max]="maxDate" onkeydown="return false"  [attr.disabled]="formAccessEmployee.controls['accessApproverId'].hasError('required') ? true : null" [matDatepicker]="picker" formControlName="dateStart" value="date" (dateChange)="clearPersonDate()">
                  <mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker  #picker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="formAccessEmployee.controls['dateStart'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'EmployeeAccessPortal.warn' | translate}}</mat-error></h5></span>
                </div>
              </div>

            </div>
            <div class="col-md-4 col-sm-6" >
              <div class="form-group" *ngIf="formAccessEmployee.controls['dateIndefinite'].value==false">
                <label class="o-title o-title--required o-title--label ">{{'EmployeeAccessPortal.labelTo' | translate}}</label>
                <mat-form-field style="width: 100%;" appearance="standard">
                  <input  matInput onkeydown="return false" [min]="formAccessEmployee.controls.dateStart.value" [max]="maxDateTo"  [matDatepicker]="picker2" formControlName="dateEnd" value="date" (dateChange)="dataEntries=[]">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>

                <div *ngIf="formAccessEmployee.controls['dateEnd'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'EmployeeAccessPortal.warn' | translate}}</mat-error></h5></span>
                </div>
              </div>
              <div class="form-group"  >
                <label class="o-title o-title--required o-title--label " *ngIf="formAccessEmployee.controls['dateIndefinite'].value==true">{{'EmployeeAccessPortal.labelTo' | translate}}</label>
                <div class="o-form__checkbox u-mb20" style="margin-top: 11px;">
                    <input type="checkbox" value="value" (change)="changeLimitDate()" formControlName="dateIndefinite" name="ConfirmDate" required><span></span>
                    <p class="open_modal"  >{{'EmployeeAccessPortal.undefinedAccess' | translate}}</p>
                </div>
            </div>
            </div>
          </div>
          <!-- Msg validator date mora than 30days-->
          <div *ngIf="dateValn" style="margin-bottom: 15px;width:100%; background-color: #F2F0E9" align="center">
            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; ">
              <i class="icon icon-warning"></i> {{'EmployeeAccessPortal.daysValidation' | translate}}</mat-error></h5></span>
          </div>
          <div *ngIf="dateValn48" style="margin-bottom: 15px;width:100%; background-color: #F2F0E9" align="center">
            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; ">
              <i class="icon icon-warning"></i> {{'EmployeeAccessPortal.warn48hrs' | translate}}</mat-error></h5></span>
          </div>

          <div *ngIf="controlDateAddError && (formAccessEmployee.controls['dateStart'].hasError('required') || formAccessEmployee.controls['dateEnd'].hasError('required'))" style="width:100%; background-color: #F2F0E9" align="center">
            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'EmployeeAccessPortal.warn' | translate}}</mat-error></h5></span>
        </div>
          <div *ngIf="controlSiteZoneCCError " style="width:100%; background-color: #F2F0E9" align="center">
            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'EmployeeAccessPortal.labelNeedAccessPlace' | translate}}</mat-error></h5></span>
        </div>
          <div class="row">
            <div class="col-md-12">
              <label class="o-title o-title--label">{{'EmployeeAccessPortal.labelAccessPurpose' | translate}}</label>
              <textarea class="o-form__textarea " placeholder="{{'EmployeeAccessPortal.placeholderAccessPurpose' | translate}}" formControlName="purpuse"
              [attr.disabled]="formAccessEmployee.controls['dateEnd'].hasError('required') ? true : null"
                bind-style.background-color="formAccessEmployee.controls['dateEnd'].hasError('required') ? '#F2F0E9' : 'white'"
                bind-style.cursor="formAccessEmployee.controls['dateEnd'].hasError('required') ? 'no-drop' : ''"



              ></textarea>
            </div>
          </div>
          <div class="hr orange u-mt40"></div>
          <div class="row u-pt40">
            <div class="col-md-12">
              <h2 class="o-title o-title--medium o-title--orange">{{'EmployeeAccessPortal.titleEmployeeInfo' | translate}}</h2>
            </div>
            <div class="col-md-12 u-pt20">
              <div class="o-etable">
                <div class="o-etable__employee">
                  <div class="row">
                    <div class="col-md-1 col-xs-2">
                      <p> <strong>Nº</strong></p>
                    </div>
                    <div class="col-md-1 col-xs-2">
                      <p class="u-hide__desktop"> <strong>{{'EmployeeAccessPortal.colType' | translate}}</strong></p>
                    </div>
                    <div class="col-md-2 col-xs-10">
                      <p class="u-show__mobile"> <strong>{{'EmployeeAccessPortal.colDetails' | translate}}</strong></p>
                      <p class="u-hide__desktop"> <strong>{{'EmployeeAccessPortal.colRutpass' | translate}}</strong></p>
                    </div>
                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                      <p class="u-hide__desktop"> <strong>{{'EmployeeAccessPortal.colName' | translate}}</strong></p>
                    </div>
                    <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                      <p class="u-hide__desktop"> <strong>{{'EmployeeAccessPortal.colEmail' | translate}}</strong></p>
                    </div>
                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p class="u-hide__desktop"> <strong>{{'EmployeeAccessPortal.colCompany' | translate}}</strong></p>
                      </div>
                      <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p class="u-hide__desktop"> <strong> {{'EmployeeAccessPortal.colAction' | translate}} </strong></p>
                    </div>
                  </div>
                </div>

                <div  class="o-etable__employee "  *ngIf="dataEntries.length===0">
                  <div class="row">
                    <div class="col-md-12 col-md-offset-1">
                      <p >{{'EmployeeAccessPortal.noDataWarn' | translate}}</p>
                    </div>
                  </div>
              </div>
                <div class="o-etable--body parent_etable">
                  <div class="o-etable__employee "> <!--a class="btn-remove_clone_employee" ></a>-->
                    <div class="row"  *ngFor="let employee of dataEntries; let i = index">
                      <div class="col-md-1 col-xs-2">
                        <p><span>{{i+1}}</span></p>
                      </div>
                      <div class="col-md-1 col-xs-2 " >
                      <p>
                        <span bind-style.color="employee.status === 0? 'green': employee.status === 1? 'rgb(246, 123, 0)': 'red'" *ngIf="employee.passportNumber">{{'EmployeeAccessPortal.labelPassport' | translate}}</span>
                        <span bind-style.color="employee.status === 0? 'green': employee.status === 1? 'rgb(246, 123, 0)': 'red'" *ngIf="employee.passportNumber && employee.nationalId"> / </span>
                        <span bind-style.color="employee.status === 0? 'green': employee.status === 1? 'rgb(246, 123, 0)': 'red'" *ngIf="employee.nationalId">RUT</span>
                      </p>
                      </div>
                      <div class="col-md-2 col-xs-10  col-md-offset-0 col-xs-offset-2">
                        <p><span *ngIf="employee.passportNumber">{{employee.passportNumber}}</span><span *ngIf="employee.passportNumber && employee.nationalId"> / </span> <span *ngIf="employee.nationalId">{{employee.nationalId}}</span></p>
                      </div>
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p>{{employee.fullName}}</p>
                      </div>
                      <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" title="{{employee.email}}">

                       <p> {{employee.email}}</p>
                      </div>
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p >{{employee.companyName}}</p>
                      </div>
                      <div align="center" class="col-md-1 col-xs-12 col-md-offset-0 col-xs-offset-0">
                        <button (click)="deletePeople(i)" style="border: 0; background-color: transparent;">
                            <svg class="bi bi-x" width="2em" height="2em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M5.646 5.646a.5.5 0 000 .708l8 8a.5.5 0 00.708-.708l-8-8a.5.5 0 00-.708 0z" clip-rule="evenodd"></path>
                                <path fill-rule="evenodd" d="M14.354 5.646a.5.5 0 010 .708l-8 8a.5.5 0 01-.708-.708l8-8a.5.5 0 01.708 0z" clip-rule="evenodd"></path>
                          </svg>
                        </button>
                    </div>
                      <div class="col-md-12 col-xs-12">
                        <h6 *ngIf="employee.status===0"><i class="icon icon-check"></i><p>{{'EmployeeAccessPortal.meetQualification' | translate}}</p></h6>
                        <h6 *ngIf="employee.status===1">
                          <i class="icon icon-warning"></i>
                          <p> {{'EmployeeAccessPortal.entry-allowed'|translate}}
                            <a style="padding-left:25px; color: rgb(246, 123, 0); cursor:pointer;" (click)="seeQualifications(employee.qualifications)">
                              {{'EmployeeAccessPortal.labelStatus' | translate}}
                            </a>
                          </p>
                        </h6>
                       <!-- <h6 *ngIf="employee.status===1"><i class="icon icon-arrow"></i><span>Doesn’t meet the qualifications of the selected site.</span><a class="open_modal "   style="float: right; color: #C52D10;" (click)="seeQualifications(employee.qualifications)" >Qualifications Status</a></h6>-->
                        <h6 *ngIf="employee.status===2 ">
                          <i class="icon icon-close"></i>
                          <p>{{'EmployeeAccessPortal.notQualification' | translate}}
                            <a *ngIf="employee.qualifications"    style="padding-left:25px; color: #C52D10; cursor:pointer;" (click)="seeQualifications(employee.qualifications)">
                              {{'EmployeeAccessPortal.labelStatus' | translate}}
                            </a>
                          </p>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="o-etable__employee o-etable__employee--action">
                  <div class="row"  *ngIf="!this.formRadio.value.document || this.formRadio.value.document==='nationalId' ">


                    <div class="col-md-2 col-md-offset-1">
                      <h5>
                        <div>{{'EmployeeAccessPortal.dataEntry' | translate}}</div><span>{{'EmployeeAccessPortal.rutpassEmployee' | translate}}</span>
                      </h5>
                    </div>
                    <form class="o-form" [formGroup]="formRadio" >
                        <div class="col-md-2 col-md-offset-0">


                            <label style="cursor:pointer; padding-bottom: 5px;">
                                <input class="form-check-input" type="radio" formControlName="document" value="nationalId" id="nationalId" style="cursor:pointer"> {{'EmployeeAccessPortal.labelRUT' | translate}} <br>
                            </label><br>
                            <label style="cursor:pointer;">
                                <input class="form-check-input" type="radio" formControlName="document" value="passportNumber" id="passportNumber" style="cursor:pointer"> {{'EmployeeAccessPortal.labelPassport' | translate}}
                            </label>
                            <label><mat-error *ngIf="formRadio.controls['document'].hasError('required') && radioPress"> {{'EmployeeAccessPortal.OptDocumentType' | translate}} </mat-error></label>

                        </div>
                        <div class="col-md-3 col-md-offset-2">

                            <div class="o-etable__addemployee">

                                <input style="background-color: white;" class="o-form__input" formControlName="ID" type="text" placeholder="RUT">
                                <mat-error *ngIf="formRadio.controls['ID'].hasError('validateRUN')">
                                  <i class="icon icon-close" ></i> {{'EmployeeAccessPortal.validRUT' | translate}} {{'EmployeeAccessPortal.rutExample' | translate}}
                              </mat-error>

                            </div>
                            <mat-error *ngIf="formRadio.controls['ID'].hasError('required') && radioPress "> {{'EmployeeAccessPortal.documentRequired' | translate}} </mat-error>
                        </div>
                        <div class="col-md-2">
                          <a (click)="add()" class="btn btn--primary" id="clone-add_employee" >{{'EmployeeAccessPortal.btnAdd' | translate}}</a></div>
                    </form>
                  </div>

                  <!-- Agrupar cod para select -->
                  <div class="row"  *ngIf="this.formRadio.value.document==='passportNumber' ">


                    <div class="col-md-2 col-md-offset-1" >
                      <h5>
                        <div>{{'EmployeeAccessPortal.dataEntry' | translate}}</div>
                            <span>{{'EmployeeAccessPortal.rutpassEmployee' | translate}}</span>
                      </h5>
                    </div>
                    <form class="o-form" [formGroup]="formRadio"   >
                        <div class="col-md-2 col-md-offset-0" >


                            <label style="cursor:pointer; padding-bottom: 5px;">
                                <input class="form-check-input" type="radio" formControlName="document" value="nationalId" id="nationalId" style="cursor:pointer" (change)="formRadio.controls['countryId'].setValue('');"> RUT <br>
                            </label><br>
                            <label style="cursor:pointer;">
                                <input class="form-check-input" type="radio" formControlName="document" value="passportNumber" id="passportNumber" style="cursor:pointer" > {{'EmployeeAccessPortal.labelPassport' | translate}}
                            </label>
                            <label><mat-error *ngIf="formRadio.controls['document'].hasError('required') && radioPress"> {{'EmployeeAccessPortal.OptDocumentType' | translate}} </mat-error></label>

                        </div>

                        <div class="col-md-2">
                            <select name="country" class="o-form__select" required style="cursor:pointer" formControlName="countryId"  required title="{{ 'EmployeeAccessPortal.tipCountry' | translate}}">
                            <option [value]="''" disabled selected>{{ 'EmployeeAccessPortal.selCountry' | translate}}</option>
                            <option [value]="country.name" *ngFor="let country of selectCountry"> <span *ngIf="getlang()==='es'">{{country.nameEs}}</span> <span *ngIf="getlang()==='en'">{{country.name}}</span></option>
                            </select>
                        </div>

                        <div class="col-md-3 col-md-offset-0">

                            <div class="o-etable__addemployee">

                                <input style="background-color: white;" class="o-form__input" formControlName="ID" type="text" placeholder="{{'EmployeeAccessPortal.placeholderPassport' | translate}}">


                            </div>
                            <mat-error *ngIf="formRadio.controls['ID'].hasError('required') && radioPress "> {{'EmployeeAccessPortal.documentRequired' | translate}} </mat-error>
                        </div>
                        <div class="col-md-2">
                          <a (click)="add()" class="btn btn--primary"  id="clone-add_employee">{{'EmployeeAccessPortal.btnAdd' | translate}}</a>
                        </div>
                    </form>
                  </div>

                </div>


              </div>
            </div>
          </div>
          <div class="o-etable__group" style="padding-top: 10px;">
            <div *ngIf="controlRepeatPerson" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'EmployeeAccessPortal.personEntered' | translate}}</mat-error></h5></span>
            </div>
            <div *ngIf="controlCountryError && formRadio.controls['countryId'].hasError('required') " style="width:100%; background-color: #F2F0E9" align="center">
              <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'EmployeeAccessPortal.notCountry' | translate}}</mat-error></h5></span>
          </div>
            <div *ngIf="controlNotFoundError" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'EmployeeAccessPortal.personNotFound' | translate}}</mat-error></h5></span>
            </div>
            <div *ngIf="controlNotContractorError" style="width:100%; background-color: #F2F0E9" align="center">
              <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'EmployeeAccessPortal.no-contractor' | translate}}</mat-error></h5></span>
          </div>
            <div *ngIf="controlPeopleInError" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'EmployeeAccessPortal.personWarn' | translate}}</mat-error></h5></span>
            </div>
           <!-- <div *ngIf="controlMissImage" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>
                    You must attach photos to all people</mat-error></h5></span>
            </div>-->
        </div>

          <div class="row">
             <div class="col-md-12 u-pt20">
                <div class="o-form__checkbox u-mb20">
                    <input type="checkbox" value="value" formControlName="Confirm" name="Confirm" required><span></span>
                    <a class="open_modal" (click)="openDialog()" data="terms" style="cursor:pointer">{{'EmployeeAccessPortal.confirm' | translate}}</a>
                </div>
                 <div align="center" *ngIf="formAccessEmployee.controls['Confirm'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-0">
                    <h5 style="padding: 15px;"><i class="icon icon-close"></i> <mat-error style=" white-space: normal;">  {{ 'EmployeeAccessPortal.confirmTerms' | translate}}</mat-error></h5>
                </div>

                <br>
            </div>
            <div  class="col-md-12 u-pt50">
              <span class="btn" [routerLink]="['/']">{{'EmployeeAccessPortal.btnCancel' | translate}}</span>
              <button *ngIf="buttonEnable" class="btn btn--primary">{{'EmployeeAccessPortal.btnGenerate' | translate}}</button>
            </div>
          </div>
        </form>
      </div>
